<div class="overlay">
	<div class="overlay__inner">
		<div class="overlay__content"><mat-spinner class="spinner"></mat-spinner></div>
	</div>
</div>
